import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49b78cf7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-footer" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("确定")

import { ref } from 'vue'
    import { GETAuth } from '@/service/index'

    
export default /*#__PURE__*/_defineComponent({
  props: ['item'],
  emits: ['callback'],
  setup(__props, { expose, emit: emits }) {

const props = __props

    
    
    const item = ref(props.item)
    const show = ref(false)
    const list = ref([])

    
    const getInfo = async () => {
        let { data }  = await GETAuth(`/api/select/zs`, {
            params: {
                    subjectCode: item.value.subjectcode,
                    positionCode: item.value.positioncode,
                    idCardNo: item.value.idcardno
                }
            }
        )
        if ( data.code === 200 ) {
            show.value = true
            let { records } = data.data
            list.value = records

        }
    }

    const handleClose = () => {
        list.value = []
        show.value = false
        emits('callback')
    }

    expose({ getInfo })



return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: show.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    title: "证件列表",
    width: "70%",
    "before-close": handleClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, { onClick: handleClose }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_table, {
        data: list.value,
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "studenName",
            label: "姓名",
            width: "80"
          }),
          _createVNode(_component_el_table_column, {
            prop: "companyName",
            label: "公司"
          }),
          _createVNode(_component_el_table_column, {
            prop: "subjectName",
            label: "类型一",
            width: "180"
          }),
          _createVNode(_component_el_table_column, {
            prop: "positionType",
            label: "类型二",
            width: "180"
          }),
          _createVNode(_component_el_table_column, {
            prop: "nextTime1",
            label: "再培训日期1",
            width: "180"
          }),
          _createVNode(_component_el_table_column, {
            prop: "nextTime2",
            label: "再培训日期2",
            width: "180"
          }),
          _createVNode(_component_el_table_column, {
            prop: "effectiveDate",
            label: "有效日期"
          }),
          _createVNode(_component_el_table_column, {
            prop: "expirationDate",
            label: "失效日期"
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})